import React, { useRef, useState } from 'react'
import { BankModalContainer, BankWrapper, BankModalBackground } from './style'
import { MdClose } from 'react-icons/md'
import styled from 'styled-components/macro'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { action } from 'typesafe-actions'
import { useNavigate } from 'react-router-dom'
import { TargetTimeLine } from '../PlanTimeLine'
const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  /* @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 36px;
    height: 36px;
    top: 60px;
  } ; */
`

const TargetTimeLineModal = ({ showModal, setShowModal }: any) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [copied, setCopied] = useState('')

  const componentRef = useRef<HTMLDivElement>(null)

  const closeModal = (e: any) => {
    if (componentRef.current !== e.target) {
      setShowModal(false)
    }
  }

  const copyCodeToClipBoard = (code: string) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code)
      // setShowAlert(true)
    }
  }
  const handleTransfer = (e: any) => {
    e.preventDefault()
    dispatch(action(PlanTypes.CLEAR_PAYMENT_FORM))
    navigate('/homepage')
  }

  return (
    <BankModalContainer>
      {showModal ? (
        <BankModalBackground>
          <BankWrapper>
            <ClosedModalButton onClick={closeModal} />
            <TargetTimeLine />
          </BankWrapper>
        </BankModalBackground>
      ) : null}
    </BankModalContainer>
  )
}

export { TargetTimeLineModal }
